import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';
import { apiAdmin } from '@src/logic/services/endpoints';
import { useStores } from '@src/stores';

export const useAdminNotesAnalyticsTab = ({
  userId,
  onSuccess,
  enabled = true,
}: {
  userId: string;
  onSuccess?: (data: string) => void;
  enabled?: boolean;
}) => {
  const { auth } = useStores();

  return useQuery({
    queryKey: queryKeys.admin.analyticsTab(),
    queryFn: async () => {
      const items = await apiAdmin.getAdminNotesAnalyticsTab(auth, userId);

      return items;
    },
    onSuccess: onSuccess,
    enabled: enabled,
  });
};
